import React, { Component } from 'react'
import * as R from 'ramda'
import { withRouter } from 'react-router-dom'
import Logo, { Variant } from '@components/logo'
import { Choose, Otherwise, When } from 'tsx-control-statements/components'
import { PARTNERS_NAME_REFERENCE } from 'constants/partner'
import withConnect from './connector'
import Network from './Network'
import Technical from './Technical'
import { LOGO_HEIGHT, ErrorContainerWrapper as Wrapper } from './style'
import { Props } from './types'

class Error extends Component<Props> {
  reloadApp = (): void => { window.location.reload() }

  render (): React.ReactNode {
    const {
      culture,
      children,
      emptySaleResourcesErrors,
      errors,
      history,
      homePageURL,
      networkErrors,
      partner,
      resourceFetchErrors,
      versionFetchErrors
    } = this.props

    return (
      <Choose>
        <When condition={R.length(errors)}>
          <Wrapper>
            <header className='Error__Header'>
              <Logo
                height={LOGO_HEIGHT}
                variant={`${PARTNERS_NAME_REFERENCE[partner] as string}_${culture}` as Variant}
              />
            </header>

            <main className='Error__Content'>
              <Choose>
                <When condition={R.length(emptySaleResourcesErrors) || R.length(resourceFetchErrors) || R.length(versionFetchErrors)}>
                  <Technical
                    resourceType={R.path(
                      ['payload', 'type'],
                      R.last(emptySaleResourcesErrors) ||
                      R.last(resourceFetchErrors) ||
                      R.last(versionFetchErrors)
                    )}
                    homePageURL={homePageURL}
                    onReloadApp={this.reloadApp}
                    onPreviousPage={history.goBack}
                  />
                </When>

                <When condition={R.length(networkErrors)}>
                  <Network onReloadApp={this.reloadApp} />
                </When>
              </Choose>
            </main>
          </Wrapper>
        </When>

        <Otherwise>
          {children}
        </Otherwise>
      </Choose>
    )
  }
}

export { Error }

export default R.compose(
  withConnect,
  withRouter
)(Error)
